<template>
  <header class="main-header">
    <!-- Logo -->
    <a href="#" class="logo" style="position: fixed;">
      <!-- mini logo for sidebar mini 50x50 pixels -->
      <span class="logo-mini"><img style="max-width: 35px;" src="../../../assets/circle-logo.png"></span>
      <!-- logo for regular state and mobile devices -->
      <span class="logo-lg"><img src="../../../assets/circle-logo.png"></span>
    </a>

    <!-- Header Navbar: style can be found in header.less -->
    <nav class="navbar navbar-static-top">
      <div class="container">
        <div class="navbar-header">
          <a href="../../index2.html" class="navbar-brand"><img style="max-width: 35px;" src="../../../assets/circle-logo.png"></a>
          <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar-collapse" aria-expanded="false">
            <i class="fa fa-bars"></i>
          </button>
        </div>

        <!-- Collect the nav links, forms, and other content for toggling -->
        <div class="navbar-collapse pull-left collapse" id="navbar-collapse" aria-expanded="false" style="height: 1px;">

        </div>
        <!-- /.navbar-collapse -->
        <!-- Navbar Right Menu -->
        <div class="navbar-custom-menu">
        <ul class="nav navbar-nav">
          <!-- Messages: style can be found in dropdown.less-->
          <li class="dropdown messages-menu">
            <a>Support</a>
          </li>
        </ul>
        </div>
        <!-- /.navbar-custom-menu -->
      </div>
      <!-- /.container-fluid -->
    </nav>
  </header>
</template>

<script>
// import router from '../../../router/index'
// import axios from 'axios'
// import { BaseURL } from '../../../shared/classes'
// import $ from 'jquery'

export default {
  name: 'TheHeader',
  data () {
    return {
    }
  }
}
</script>
<style scoped>
.skin-blue .main-header .navbar .nav>li>a {
    color: #5bad2b;
    background-color: #32373C;
}
.skin-blue .main-header .navbar {
  background-color: #32373C;
  opacity: 1;
  border-bottom: 0.5px solid #32373C;
  color:black;
}
.sidebar-toggle:hover {
    background-color: #f1f1f1 !important;
}
.sidebar-toggle {
  color:black !important;
}
.skin-blue .main-header .navbar .nav>li>a:hover, .skin-blue .main-header .navbar .nav>li>a:active {
  background: #32373C;
  color: #5bad2b;
}
.skin-blue .main-header .navbar .nav>li>a {
    color: #fff;
}
.skin-blue .main-header .logo {
    background-color: #2D2D2D !important;
    color: #fff;
    border-bottom: 0 solid transparent;
    /* margin-bottom: 4px; */
}
.skin-blue .main-header li.user-header {
    background-color: #5bad2b;
}
.user-image {
  width: 30px !important;
  height: 30px !important;
  border-radius: 50%;
  margin-top: -5px !important;
}
/* start popup */
.modal.left .modal-dialog,
.modal.right .modal-dialog {
  position: fixed;
  margin: auto;
  width: 320px;
  height: 100%;
  -webkit-transform: translate3d(0%, 0, 0);
      -ms-transform: translate3d(0%, 0, 0);
        -o-transform: translate3d(0%, 0, 0);
          transform: translate3d(0%, 0, 0);
}

.modal.left .modal-content,
.modal.right .modal-content {
  height: 100%;
  overflow-y: auto;
}

.modal.left .modal-body,
.modal.right .modal-body {
  padding: 15px 15px 80px;
}

/*Left*/
.modal.left.fade .modal-dialog{
  left: -320px;
  -webkit-transition: opacity 0.3s linear, left 0.3s ease-out;
      -moz-transition: opacity 0.3s linear, left 0.3s ease-out;
        -o-transition: opacity 0.3s linear, left 0.3s ease-out;
          transition: opacity 0.3s linear, left 0.3s ease-out;
}
.modal.left.fade.in .modal-dialog{
  left: 0;
}
/*Right*/
.modal.right.fade .modal-dialog {
  right: -320px;
  -webkit-transition: opacity 0.3s linear, right 0.3s ease-out;
      -moz-transition: opacity 0.3s linear, right 0.3s ease-out;
        -o-transition: opacity 0.3s linear, right 0.3s ease-out;
          transition: opacity 0.3s linear, right 0.3s ease-out;
}
.modal.right.fade.in .modal-dialog {
  right: 0;
}
/* ----- MODAL STYLE ----- */
.modal-content {
  border-radius: 0;
  border: none;
}

.modal-header {
  border-bottom-color: #EEEEEE;
  background-color: #FAFAFA;
}
.modal-dialog {
  width: 307px !important;
  margin: 0px auto !important;
  border-top: 3px solid #60AB2F;
}
.modal-header .close {
  margin-top: 4px;
}
.products-list .product-img img {
    width: 30px;
    height: 30px;
}
.products-list .product-info {
    margin-left: 49px;
}
.modal.right .modal-body {
    padding: 1px 5px 80px 1px;
}
.products-list .product-description {
  display: block;
  color: #999;
  overflow: hidden;
  word-wrap: break-word;
  /* white-space: nowrap; */
  text-overflow: ellipsis;
}
.mins {
  color: #AEAEAE;
  font-weight: 100;
}
.product-description {
  font-size: 12px;
  color: #404040 !important;
}
.date-title {
  background-color: #f4f4f4;
  padding: 4px;
  width: 100%;
}
.logmenu>li .menu>li>a {
    padding: 6px !important;
    color: #444;
}
.logmenu>li .menu>li>a:hover {
    padding: 6px !important;
    color: #444;
    border-left: 3px solid #60AB2F;
}
.main-header {
  position: fixed;
  max-height: 100px;
  z-index: 1030;
  width: 100%;
}
.product-description {
  max-width: 200px;
  word-wrap: break-word !important;
  white-space: inherit !important;
}
.title-name {
  font-weight: 600 !important;
}
.job_title {
  font-weight: 600;
  color: #5bad2b !important;
}
span.job_title {
    color: #5bad2b !important;
}
.v-time-ago__text {
  font-size: 12px !important;
  cursor: pointer;
  color: #AEAEAE;
}
.mins {
  margin-top: -7px !important;
}
.span.v-time-ago__text {
    text-decoration: none;
    line-height: 20px;
    letter-spacing: .1px;
    letter-spacing: 0.09px;
    color: #AEAEAE;
    opacity: 1;
}
i.fa.fa-lg:hover {
    color: #5bad2b !important;
}
.products-list>.item {
  padding: 6px 0;
  border-left: 3px solid #ffffff;
  background: #fff;
  margin-left: 0px;
}
.products-list>.item:hover {
  padding: 6px 0;
  border-left: 3px solid #5bad2b;
  background: #f4f4f4;
  margin-left: 0px;
}
.modal-content {
  border-left: 1px solid #ccc;
}
.product-img {
    text-align: center;
}
.circle-title {
  height: 40px;
  widows: 40px;
  font-size: 12px;
  font-weight: 600;
  color: #B3B3B3;
  margin-left: -8px;
}
.products-list>.item:hover .product-img {
  background-color: #FFFFFF;
}
.product-img {
  height: 35px;
  width: 35px;
  background-color: #F1F1F1;
  border-radius: 25px;
  padding-top: 7px;
  margin-left: 7px;
}
.navbar-brand {
  padding: 9px 15px !important;
}
</style>
